export default function draggableShiftIsDragging($parse) {
  'ngInject';

  return {
    scope: true,
    controllerAs: 'draggableShiftIsDraggingCtrl',
    controller($scope, $element, $attrs) {
      'ngInject';

      const { assign } = $parse($attrs.draggableShiftIsDragging);

      this.setDragging = (val) => {
        if ($scope.$$destroyed) {
          console.warn('draggableShiftIsDragging: scope desroyed');
        }

        if (assign) {
          $scope.$evalAsync(() => {
            assign($scope, val);
          });
        }
      };

      $scope.$on('$destroy', () => {
        assign?.($scope, false);
      });
    },
  };
}
